
/**
 * Lildog Referral Tracking
 * Stores referral IDs for 30 days and attaches them
 * to Shopify carts and orders.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'lildog_referral';
  const ATTRIBUTE_KEY = 'Referral ID';
  const EXPIRY_DAYS = 30;

  const params = new URLSearchParams(window.location.search);
  const incomingRef = params.get('ref');
  const now = Date.now();

  if (incomingRef && /^ohs_[a-z0-9_-]{1,60}$/i.test(incomingRef)) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        id: incomingRef,
        expires: now + EXPIRY_DAYS * 86400000
      }));
    } catch (error) {
      console.warn('Referral storage unavailable');
    }
  }

  function getReferral() {
    try {
      const stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!stored) return null;

      if (stored.expires <= Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return stored.id;
    } catch (error) {
      return null;
    }
  }

  async function syncReferralToCart() {
    const referralId = getReferral();
    if (!referralId) return;

    try {
      const response = await fetch(
        (window.Shopify?.routes?.root || '/') + 'cart/update.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            attributes: {
              [ATTRIBUTE_KEY]: referralId
            }
          })
        }
      );

      if (!response.ok) {
        console.warn('Referral cart sync failed');
      }
    } catch (error) {
      console.warn('Referral cart sync unavailable');
    }
  }

  syncReferralToCart();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) syncReferralToCart();
  });
})();
